import {combineReducers, createStore, applyMiddleware, compose} from 'redux'
import {Provider} from 'react-redux'
import promise from 'redux-promise-middleware'
import {CityDataReducer} from './features/getCityData'
import {NearByCitiesReducer} from './features/getNearByCities'
import {
  ModalReducer,
  FrameReducer,
  ModalVideoReducer,
  ModalDialogReducer,
  PopupLocateCityReducer,
  SubscriptionStatusReducer,
} from './features/getModal'
import {SearchResultReducer} from './features/getSearchResult'
import {TestimonialsReducer} from './features/getTestimonials'
import {LangsReducer, ContentReducer} from './features/getLangs'
import {CityApiReducer} from './features/getCityApi'
import {CityAliasReducer} from './features/getCityAlias'
import {GetVideoReducer} from './features/getVideo'
import {CurrentPageReducer} from './features/getCurrentPage'
import {FullListReducer} from './features/getFullList'
import {FilterListReducer} from './features/getFillterList'
import {CoordsReducer} from './features/getCoords'
import {GroupInfoReducer} from './features/getGroupInfo'

import withProvider from './withProvider'

/**
 * Create root reducer, containing
 * all features of the application
 */
const rootReducer = combineReducers({
  currentPage: CurrentPageReducer,
  cityAlias: CityAliasReducer,
  videoLink: GetVideoReducer,
  cityData: CityDataReducer,
  nearByCities: NearByCitiesReducer,
  openModal: ModalReducer,
  openFrame: FrameReducer,
  openModalVideo: ModalVideoReducer,
  modalDialogStatus: ModalDialogReducer,
  popupLocateCityStatus: PopupLocateCityReducer,
  subscriptionStatus: SubscriptionStatusReducer,
  searchData: SearchResultReducer,
  testimonials: TestimonialsReducer,
  languages: LangsReducer,
  aboutContent: ContentReducer,
  cityAPI: CityApiReducer,
  fullList: FullListReducer,
  filterList: FilterListReducer,
  coords: CoordsReducer,
  groupInfo: GroupInfoReducer,
})

/**
 * Initialize Redux Dev Tools,
 * if they are installed in browser.
 */
/* eslint-disable no-underscore-dangle */
/** Use Redux compose, if browser doesn't have Redux devtools */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
/* eslint-enable */

/** Create Redux store with root reducer and middleware included */
export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(promise)))

/**
 * Create HOC, which wraps given Component with Redux Provider
 */
export default withProvider({store, Provider})
